import { ApiService } from '../../services/api_service';
import breadcrumbStyle from '../start/BreadcrumbNavigation.less';
import * as classNames from 'classnames';
import * as config from '../../wips.config.js';
import { ContextService } from '../../services/context_service';
import { DatenauswertungBWL } from './DatenauswertungBWL';
import { DatenauswertungCO2Tabs } from './DatenauswertungCO2Tabs';
import { DatenauswertungEnergiekennzahlen } from './DatenauswertungEnergiekennzahlen';
import { DatenauswertungFahrzeuge } from './DatenauswertungFahrzeuge';
import { DatenauswertungKennzahlenBerechnung } from './DatenauswertungKennzahlenBerechnung';
import { DatenauswertungKraftstoffe } from './DatenauswertungKraftstoffe';
import { DatenauswertungMaschinenUndAnlagen } from './DatenauswertungMaschinenUndAnlagen';
import { DatenauswertungStromNeu } from './DatenauswertungStromNeu';
import { DatenauswertungVsmeTab } from './DatenauswertungVsmeTab';
import { DatenauswertungWaerme } from './DatenauswertungWaerme';
import { DatenauswertungWasser } from './DatenauswertungWasser';
import { ErneuerbareEnergien } from '../informationen_hilfe/ErneuerbareEnergien';
import { getDefaultHelpIcon } from '../../helpers/getDefaultHelpIcon';
import { getGewerk } from '../../main/functions/getGewerk';
import { getGewerkName, getWZobject } from '../../main/functions/getGewerk';
import { getLastDataYear } from './helper/getLastDataYear';
import { hasErneuerbareEnergien } from '../../main/functions/hasErneuerbareEnergien';
import { isEnableEnergiesteuerrueckerstattung } from '../dateneingabe/assistent/assistent_helpers';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { ZusatztoolsSteuer } from '../zusatztools/ZusatztoolsSteuer';

interface DatenauswertungProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    reloadData: () => void;
    routing: any;
    standortTid: number;
    standortName: string;
}
interface DatenauswertungState {
    tabIndex: number;
}

export class Datenauswertung extends React.Component<DatenauswertungProps, DatenauswertungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxDatenauswertung') || 0
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;

    private devFeaturesMap: any = config.devFeaturesMap || {};

    componentDidMount(): void {
        this.checkRouting();
    }

    componentDidUpdate(prevProps: any): void {
        if (this.props.routing !== prevProps.routing) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG;
        if (routing.path && routing.path[tabName] !== undefined) {
            // if ((routing.path.terminateOn || null) === tabName) {
            //     this.props.onRoutingChange({});
            // }
            // this.setTabIndex(routing.path[tabName], routing);
            if (this.state.tabIndex === routing.path[tabName]) {
                if (routing.path.terminateOn === tabName) {
                    this.props.onRoutingChange({});
                }
            } else {
                this.setTabIndex(routing.path[tabName], routing);
            }
        }
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            const routing: any = JSON.parse(JSON.stringify(this.props.routing || {}));
            const tabName: string = RoutingIDs.TABS_DATENAUSWERTUNG;
            if (routing.path && routing.path[tabName] === undefined) {
                // init default tabIndex
                routing.path[tabName] = this.state.tabIndex;
                this.props.onRoutingChange(routing);
            }
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set('tabIdxDatenauswertung', tabIndex);
                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            }, 0);
        }
    }

    render(): JSX.Element {
        const data: any = this.props.data || {};
        const gewerk = getGewerk(data);

        if (!gewerk) {
            return (
                <div style={{ padding: 10 }}>
                    <br /><br />
                    Dieser Bereich steht aktuell noch nicht zur Verfügung,
                    bitte konfigurieren Sie zunächst ein Gewerk im Bereich Dateneingabe/Betriebliche Daten/Unternehmensdaten!
                </div>
            );
        }

        const kennzahlen: any = this.props.standortTid
            ? (data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[this.props.standortTid] || {}
            : data[IDs.KENNZIFFERN_BERECHNET] || {};
        const flags: any = kennzahlen.flags || {};
        const isCfm: boolean = (this.props.data || {}).MODUL_SELECTED === 'cfm';
        const konfiguration: any = (data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        let disabledBetriebsdaten: boolean = !flags.hasBetriebsdaten;
        let disabledCO2: boolean = !flags.hasCO2;
        let disabledEnergiekennzahlen: boolean = !flags.hasKraftstoffe && !flags.hasWaerme && !flags.hasStrom;
        let disabledErneuerbareEnergien: boolean = konfiguration.daten_erneuerbare_energien_orig !== 1
            || !hasErneuerbareEnergien(data, this.props.standortTid);
        let disabledFahrzeuge: boolean = !flags.hasFahrzeuge || !gewerk || konfiguration.daten_fahrzeuge_orig !== 1 || isCfm;
        let disabledKennzahlenberechnung: boolean = !this.apiService.isAdmin();
        let disabledKraftstoffe: boolean = !flags.hasKraftstoffe;
        let disabledMaschinen: boolean = !flags.hasMaschinen || !gewerk || konfiguration.daten_maschinen_orig !== 1 || isCfm;
        const disabledStrom: boolean = !flags.hasStrom;
        let disabledVsme: boolean = konfiguration.vsme_orig !== 1 || !this.props.standortTid;
        let disabledWaerme: boolean = !flags.hasWaerme;
        let disabledWasser: boolean = !flags.hasWasser;
        const hasNothing: boolean = disabledKraftstoffe && disabledWaerme && disabledStrom && disabledWasser && disabledFahrzeuge
            && disabledBetriebsdaten && disabledMaschinen && disabledErneuerbareEnergien && disabledCO2 && disabledVsme;
        const gewerkName: string = (getGewerkName(this.props.data) || '').trim().toLowerCase();

        // Für die Standorte (Hauptsitz + Filialen) wird keine eigene standortspezifische Steuerauswertung generiert.
        const isStandortspezifisch: boolean = this.props.standortTid > 0;
        const isGesamt = !isStandortspezifisch;
        const keinEnergiesteuer: boolean = (+(getWZobject(this.props.data) || {}).produzierendes_gewerbe || 0) === 0 || gewerkName === 'kein handwerk' || gewerkName === 'handwerkskammer';
        const disabledEnergiesteuer: boolean = !isGesamt || keinEnergiesteuer;

        // Strom- und Energiesteuer-Modul
        if ((this.props.data || {}).MODUL_SELECTED === 'steuer') {
            const enableEnergiesteuerrueckerstattung: boolean = isEnableEnergiesteuerrueckerstattung(data[IDs.ENT_KONFIGURATION] || []);
            disabledWaerme = !enableEnergiesteuerrueckerstattung || disabledWaerme;
            disabledKraftstoffe = true;
            disabledWasser = true;
            disabledEnergiekennzahlen = true;
            disabledBetriebsdaten = true;
            disabledMaschinen = true;
            disabledFahrzeuge = true;
            disabledErneuerbareEnergien = true;
            disabledCO2 = true;
            disabledVsme = true;
            disabledKennzahlenberechnung = true;
        }

        if (hasNothing) {
            return (
                <div style={{ padding: 10 }}>
                    Für diese Standort sind keine Auswertungen verfügbar! Bitte geben Sie zunächst Daten in den jeweiligen Bereichen ein.
                </div>
            );
        }
        const selectedIndex = this.state.tabIndex;

        if (
            (selectedIndex === 0 && disabledStrom)
            || (selectedIndex === 1 && disabledWaerme)
            || (selectedIndex === 2 && disabledKraftstoffe)
            || (selectedIndex === 3 && disabledWasser)
            || (selectedIndex === 4 && disabledEnergiekennzahlen)
            || (selectedIndex === 5 && disabledEnergiesteuer)
            || (selectedIndex === 6 && disabledBetriebsdaten)
            || (selectedIndex === 7 && disabledMaschinen)
            || (selectedIndex === 8 && disabledFahrzeuge)
            || (selectedIndex === 9 && disabledErneuerbareEnergien)
            || (selectedIndex === 10 && disabledCO2)
            || (selectedIndex === 11 && disabledVsme)
            || (selectedIndex === 12 && disabledKennzahlenberechnung)
        ) {
            if (!disabledStrom) {
                this.setState({ tabIndex: 0 });
            } else if (!disabledWaerme) {
                this.setState({ tabIndex: 1 });
            } else if (!disabledKraftstoffe) {
                this.setState({ tabIndex: 2 });
            } else if (!disabledWasser) {
                this.setState({ tabIndex: 3 });
            } else if (!disabledEnergiekennzahlen) {
                this.setState({ tabIndex: 4 });
            } else if (!disabledEnergiesteuer) {
                this.setState({ tabIndex: 5 });
            } else if (!disabledBetriebsdaten) {
                this.setState({ tabIndex: 6 });
            } else if (!disabledMaschinen) {
                this.setState({ tabIndex: 7 });
            } else if (!disabledFahrzeuge) {
                this.setState({ tabIndex: 8 });
            } else if (!disabledErneuerbareEnergien) {
                this.setState({ tabIndex: 9 });
            } else if (!disabledCO2) {
                this.setState({ tabIndex: 10 });
            } else if (!disabledVsme) {
                this.setState({ tabIndex: 11 });
            } else if (!disabledKennzahlenberechnung) {
                this.setState({ tabIndex: 12 });
            }
        }
        const jahrMax = Moment().year();
        const lastJahr = getLastDataYear(jahrMax, this.props.data);

        const extraRouting: any = {};
        if (this.props.routing && this.props.routing.path) {
            if (this.props.routing.path[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE] >= 0) {
                extraRouting[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE] = this.props.routing.path[RoutingIDs.TABS_DATENAUSWERTUNG_STANDORTE];
            }
            if (this.props.routing.path[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM] >= 0) {
                extraRouting[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM] = this.props.routing.path[RoutingIDs.TABS_STANDORTE_GRUPPE_ITEM];
            }
        }
        const tabRoutings: any[] = [
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_STROM, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WAERME, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_KRAFTSTOFFE, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_WASSER, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIEKENNZAHLEN, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ENERGIESTEUER, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_BETRIEBSDATEN, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_MASCHINEN_ANLAGEN_HEIZUNG, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_FAHRZEUGE, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_ERNEUERBARE_ENERGIEN, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_CO2_FUSS, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_VSME, ...extraRouting } },
            { path: { ...RoutingIDs.ROUTE_DATENAUSWERTUNG_KENNZAHLENBERECHNUNG, ...extraRouting } }
        ];

        return (
            <Tabs
                className='tabs-datenauswertung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, tabRoutings[tabIndex])}
            >
                <TabList style={{ display: 'none' }}>
                    <Tab disabled={disabledStrom}>{i18n('Strom', 'tab')}</Tab>
                    <Tab disabled={disabledWaerme}>{i18n('Wärme / Brennstoffe', 'tab')}</Tab>
                    <Tab disabled={disabledKraftstoffe}>{i18n('Kraftstoffe', 'tab')}</Tab>
                    <Tab disabled={disabledWasser}>{i18n('Wasser / Abwasser', 'tab')}</Tab>
                    <Tab disabled={disabledEnergiekennzahlen}>{i18n('Energiekennzahlen', 'tab')}</Tab>
                    <Tab disabled={disabledEnergiesteuer}>{i18n('Strom- / Energiesteuer', 'tab')}</Tab>
                    <Tab disabled={disabledBetriebsdaten}>{i18n('Betriebsdaten', 'tab')}</Tab>
                    <Tab disabled={disabledMaschinen}>{i18n('Maschinen / Anlagen / Heizung', 'tab')}</Tab>
                    <Tab disabled={disabledFahrzeuge}>{i18n('Fahrzeuge', 'tab')}</Tab>
                    <Tab disabled={disabledErneuerbareEnergien}>{i18n('Erneuerbare Energien', 'tab')}</Tab>
                    <Tab disabled={disabledCO2} className={classNames('react-tabs__tab', 'tab-co2')}>{i18n('CO₂-Fußabdruck', 'tab')}</Tab>
                    <Tab disabled={disabledVsme} className={classNames('react-tabs__tab', 'tab-vsme')}>VSME</Tab>
                    <Tab disabled={disabledKennzahlenberechnung}>{i18n('Kennzahlenberechnung', 'tab')}</Tab>
                </TabList>
                <TabPanel>
                    {!disabledStrom && <>
                        {getDefaultHelpIcon('datenauswertung_strom', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungStromNeu
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={lastJahr}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledWaerme && <>
                        {getDefaultHelpIcon('datenauswertung_waerme', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungWaerme
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            reloadData={this.props.reloadData}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={lastJahr}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledKraftstoffe && <>
                        {getDefaultHelpIcon('datenauswertung_kraftstoffe', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungKraftstoffe
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={lastJahr}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledWasser && <>
                        {getDefaultHelpIcon('datenauswertung_wasser', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungWasser
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={lastJahr}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledEnergiekennzahlen &&
                        <DatenauswertungEnergiekennzahlen
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={lastJahr}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {!disabledEnergiesteuer && <>
                        {/*getDefaultHelpIcon('steuer_hinweise_strom', 'Hinweise Strom', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)*/}
                        <ZusatztoolsSteuer
                            data={this.props.data}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledBetriebsdaten && <>
                        {getDefaultHelpIcon('datenauswertung_bwl', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungBWL
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={lastJahr}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledMaschinen && <>
                        {getDefaultHelpIcon('datenauswertung_maschinen', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungMaschinenUndAnlagen
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledFahrzeuge && <>
                        {getDefaultHelpIcon('datenauswertung_fahrzeuge', 'Datenauswertung - Hinweise', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <DatenauswertungFahrzeuge
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledErneuerbareEnergien && <>
                        {getDefaultHelpIcon('pageErneuerbareEnergien', 'Hilfe zu Erneuerbare Energien', this.props.data, null, null, null, breadcrumbStyle.breadcrumb_infoicon)}
                        <ErneuerbareEnergien
                            data={this.props.data}
                            standortTid={this.props.standortTid}
                        />
                    </>}
                </TabPanel>
                <TabPanel>
                    {!disabledCO2 &&
                        <DatenauswertungCO2Tabs
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                            jahrLast={lastJahr}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {!disabledVsme &&
                        <DatenauswertungVsmeTab
                            data={this.props.data}
                            onRoutingChange={this.props.onRoutingChange}
                            routing={this.props.routing}
                            standortTid={this.props.standortTid}
                            standortName={this.props.standortName}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {!disabledKennzahlenberechnung &&
                        <DatenauswertungKennzahlenBerechnung
                            data={this.props.data}
                            standortTid={this.props.standortTid}
                        />
                    }
                </TabPanel>
            </Tabs>
        );
    }
}
